import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import "../styles/auth.css"

interface LogoutModalProps {
	showModal: boolean;
	closeModal: () => void;
}

const Logout: React.FC<LogoutModalProps> = ({ showModal, closeModal }) => {

	const navigate = useNavigate();

	const handleLogout = () => {
		const AUTH_SESSION_KEY = "auth_token";
		localStorage.removeItem(AUTH_SESSION_KEY);
		localStorage.removeItem('userData');
		closeModal();
		navigate('/')
	}
	return (
		<>
			<Modal show={showModal} onHide={closeModal} className="modal-xl px-3 pb-0">
				<div className="logout-modal">
					<Modal.Header closeButton>
						<h4>Log out?</h4>
					</Modal.Header>
					<Modal.Body className="mb-0">
						<span>Are you sure you want to logout from the portal?</span>
						<div className="flex-right-btns mb-0 pb-0">
							<Button className='cancel' onClick={closeModal}>Cancel</Button>
							<Button className='proceed' onClick={handleLogout}>Logout</Button>
						</div>
					</Modal.Body>
				</div>
			</Modal>
		</>
	)
}
export default Logout;